import { useMatch } from 'react-router-dom';

export function useHeaderDisplaying() {
  const isMainPage = useMatch('/');

  return !isMainPage;
}
